import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import enviro from 'enviro';
// @ts-expect-error untyped
import { useFeedbackLoader } from 'feedback-loader/useFeedbackLoader';
import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { fetchPrerequisiteAnalyzeData, fetchPipelineSpecificAnalyzeData } from '../actions/AnalyzeActions';
import { getAccuracyBackfillStatus, getAIProjectionsOptIn, getAIProjectionsOptInFetchCompleted, getIsOptInOrBackfillFailed } from '../selectors/analyzeSelectors';
import AnalyzeOptIn from '../components/analyze/optIn/AnalyzeOptIn';
import APIFailureMessage from '../components/error/APIFailureMessage';
import { AsyncAnalyzeReportsContainer as AnalyzeReportsContainer } from './AsyncContainers';
import { PROCESSING, PROD_SURVEY_ID, QA_SURVEY_ID } from '../constants/AnalyzeConstants';
import BackfillingAIProjections from '../components/analyze/BackfillingAIProjections';
import ForecastHeader from '../components/headers/ForecastHeader';
import { getPipelineFilter } from '../selectors/filtersSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const AnalyzeWrapper = ({
  children,
  navMarker,
  testId
}) => /*#__PURE__*/_jsx(NavMarker, {
  name: navMarker,
  children: /*#__PURE__*/_jsx(DashboardPage, {
    headerComponent: /*#__PURE__*/_jsx(ForecastHeader, {
      isDetail: false
    }),
    pageLayout: "full-width",
    "data-test-id": testId,
    children: children
  })
});
const AnalyzeContainer = () => {
  var _useSelector;
  const dispatch = useDispatch();
  const pipelineId = (_useSelector = useSelector(getPipelineFilter)) === null || _useSelector === void 0 ? void 0 : _useSelector.first();
  const isOptInOrBackfillingFailed = useSelector(getIsOptInOrBackfillFailed);
  const isOptInFetchCompleted = useSelector(getAIProjectionsOptInFetchCompleted);
  const isOptedIntoAIProjections = useSelector(getAIProjectionsOptIn);
  const isBackfilling = useSelector(getAccuracyBackfillStatus) === PROCESSING;
  const {
    loadSurvey,
    clientLoaded
  } = useFeedbackLoader();
  useEffect(() => {
    if (!isOptInFetchCompleted || isOptInOrBackfillingFailed || !isOptedIntoAIProjections || !clientLoaded) {
      return;
    }
    const surveyId = enviro.isProd() ? PROD_SURVEY_ID : QA_SURVEY_ID;
    loadSurvey(surveyId, 'CSAT');
  }, [clientLoaded, isOptInFetchCompleted, isOptInOrBackfillingFailed, isOptedIntoAIProjections, loadSurvey]);

  // on load
  useEffect(() => {
    dispatch(fetchPrerequisiteAnalyzeData()).catch(() => {
      // should be caught in fetchPrerequisiteAnalyzeData
    });
  }, [dispatch]);

  // fetch AI Projection data only if opted in
  // refetch on pipeline change
  useEffect(() => {
    if (isOptedIntoAIProjections) {
      dispatch(fetchPipelineSpecificAnalyzeData()).catch(() => {
        // should be caught in fetchPipelineSpecificAnalyzeData
      });
    }
  }, [dispatch, pipelineId, isOptedIntoAIProjections]);
  if (!isOptInFetchCompleted) {
    return /*#__PURE__*/_jsx(AnalyzeWrapper, {
      navMarker: "ANALYZE_LOADING",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        marginInlineStart: "200"
      })
    });
  }
  if (isOptInOrBackfillingFailed) {
    return /*#__PURE__*/_jsx(AnalyzeWrapper, {
      navMarker: "ANALYZE_FAIL",
      children: /*#__PURE__*/_jsx(APIFailureMessage, {})
    });
  }
  if (isOptedIntoAIProjections) {
    return /*#__PURE__*/_jsx(AnalyzeWrapper, {
      navMarker: "ANALYZE_LOAD",
      testId: "analyze-container",
      children: isBackfilling ? /*#__PURE__*/_jsx(BackfillingAIProjections, {}) : /*#__PURE__*/_jsx(AnalyzeReportsContainer, {})
    });
  }
  return /*#__PURE__*/_jsx(AnalyzeWrapper, {
    navMarker: "ANALYZE_LOAD",
    testId: "analyze-container-opt-in",
    children: /*#__PURE__*/_jsx(AnalyzeOptIn, {})
  });
};
export default AnalyzeContainer;